var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.isEmpty(_vm.organisations))?_c('div',[_c('h3',{staticClass:"mb-2 t-600"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('ul',{staticClass:"mb-2 list-inline list-meta-data"},_vm._l((_vm.organisations),function(organisation,i){return _c('organisation',{key:i,attrs:{"organisation":organisation.organisation || organisation}})}),1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }